import axios from 'Axios'
const qs = require('qs');

let ajaxingUrl = []

function moveItem(arr, item) {
  const index = arr.indexOf(item)
  arr.splice(index, 1)
}

function getCookie(cookie_name) {
  var allcookies = document.cookie;
  var cookie_pos = allcookies.indexOf(cookie_name);

  if (cookie_pos != -1) {
    cookie_pos = cookie_pos + cookie_name.length + 1;
    var cookie_end = allcookies.indexOf(";", cookie_pos);

    if (cookie_end == -1) {
      cookie_end = allcookies.length;

    }
    var value = unescape(allcookies.substring(cookie_pos, cookie_end));
  }
  return value;
}

export default (function () {
  axios.defaults.retry = 4;
  axios.defaults.retryDelay = 5000;
  axios.defaults.timeout = 5000;
  axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  let source = axios.CancelToken.source();

  axios.interceptors.request.use(config => {
    if (ajaxingUrl.includes(config.url)) {
      return Promise.reject()
    }
    ajaxingUrl.push(config.url)
    return config
  })

  axios.interceptors.response.use(
    response => {
      moveItem(ajaxingUrl, response.config.url)
      // if (response.data.code != 200) {
      //   alert("Your server don't support this feature now. Please stay tuned.")
      //   return Promise.reject(`Error Url: ${response.config.url}, Error Code: ${response.data.code}`)
      // }
      return response
    },
    error => {
      if (!error) {
        return Promise.reject('cancel')
      }
      console.log(error);
      try {
        layer.open({
          content: `Service Error (${error.response.status})`,
          skin: "msg",
          time: 2
        })
        moveItem(ajaxingUrl, error.response.config.url)
      } catch (error) {
        layer.open({
          content: `Service Error`,
          skin: "msg",
          time: 2
        })
      }
      return Promise.reject()
    })

  function get(path, params) {
    var res = axios.get(path, {
      params: params,
      cancelToken: source.token
    });
    return res;
  }
  async function post(path, params) {
    // if (!params['token']) {
    //   params['token'] = getCookie('token');
    // }
    // params['group_id'] = data.group_id || '';
    // params['account_info'] = data.account_info || '';
    // params['support_type'] = 'AccountBack';
    params = qs.stringify(params)
    var res = await axios.post(path, params);
    return new Promise((resolve, reject) => {
      resolve(res);
    });
  }

  function abort() {
    source.cancel('abort');
    source = axios.CancelToken.source();
  }
  return {
    get,
    post,
    abort
  }
}())
